import { useEffect, useState } from 'react'
import { UserTypes } from '../util/constants'
import { useDispatch, useSelector } from 'react-redux'
import { plansSelectors } from '../pages/Plans/plansSlice'
import { plansApi } from '../pages/Plans/plansApi'
import notification from '../components/Notification/notification'
import { selectPlan } from '../pages/Cart/cartApi'
import { useHistory } from 'react-router'

export const BillingModes = Object.freeze({
    Annually: Object.freeze({
        id: 'annually',
        label: 'Yearly Billing',
    }),
    Monthly: Object.freeze({
        id: 'monthly',
        label: 'Monthly Billing',
    }),
})

export function usePlans(type = UserTypes.Personal) {
    const dispatch = useDispatch()
    const { push } = useHistory()

    const isFetching = useSelector(plansSelectors.getIsFetchingState)
    const plans = useSelector(plansSelectors.getPlansState)
    const errorMessage = useSelector(plansSelectors.getErrorState)
    const hasError = useSelector(plansSelectors.getHasErrorState)

    const [billingMode, setBillingMode] = useState(BillingModes.Annually.id)

    const shownPlans = plans.filter(
        plan =>
            plan.cycle.toLowerCase() === billingMode ||
            plan.cycle.toLowerCase() === 'hourly'
    )

    useEffect(() => {
        dispatch(plansApi.getPlans({ type }))
    }, [dispatch, type])

    useEffect(() => {
        if (hasError) {
            if (process.env.NODE_ENV === 'development')
                console.warn(errorMessage)
            notification.failure({
                title: 'Failed to fetch plans',
                description: errorMessage,
            })
        }
    }, [hasError, errorMessage])

    async function onSelectPlan(plan) {
        const [dismiss] = await notification.loading({
            title: 'Processing...',
        })
        const successful = await dispatch(
            selectPlan({ id: plan.subid, planInfo: plan })
        )
        dismiss()
        if (successful) {
            if (type === UserTypes.Personal) push('/app/auth/sign-up')
            else if (type === UserTypes.Business) push('/app/business/sign-up')
        } else {
            notification.failure({
                title: 'Failed to select plan',
                description:
                    'Kindly try again. Contact support if the error persists.',
            })
        }
    }

    function changeBillingMode(id) {
        setBillingMode(id)
    }

    return {
        plans: shownPlans,
        isFetching,
        hasError,
        errorMessage,
        billingMode,
        changeBillingMode,
        onSelectPlan,
    }
}
